
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { SharedService } from '@app/services/shared.service';
import {StorePagedResponse} from '@app/marketplace/stores/_models/store.interface';

@Injectable({
  providedIn: 'root'
})
export class StoreService extends SharedService {

  flashOfferSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  flashOffer$ = this.flashOfferSubject.asObservable();

  constructor(
    httpCLient: HttpClient
  ) {
    super(httpCLient);
  }

  ListStores(payload: any) {
    const url = 'api/market/store/search';
    return this.post<StorePagedResponse>(url, payload);
  }

  GetStoreDetail(payload: any) {
    const url = 'api/market/store/details';
    return this.post<any>(url, payload);
  }

}
